import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { clientsAPI, jobsAPI } from '../../lib/api';
import { Button } from '../ui/button';
import { Clock } from 'lucide-react';

/**
 * Slim banner on the Clients and Jobs pages showing how many records are parked
 * awaiting Finance approval, with a jump to the Work Orders queue. Deliberately
 * additive — neither page's own table or workflow is touched.
 */
export const PendingApprovalBanner = ({ kind }) => {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const api = kind === 'clients' ? clientsAPI : jobsAPI;
        const res = await api.list({ approval_status: 'pending_review' });
        if (!cancelled) setCount((res.data || []).length);
      } catch { /* the banner is optional; stay quiet */ }
    })();
    return () => { cancelled = true; };
  }, [kind]);

  if (!count) return null;
  const noun = kind === 'clients' ? 'client' : 'job';

  return (
    <div className="flex items-center gap-3 rounded-md border border-amber-300
      bg-amber-50 px-4 py-2.5"
      data-testid={`pending-approval-banner-${kind}`}>
      <Clock className="w-4 h-4 text-amber-600 shrink-0" />
      <p className="text-sm text-amber-900 flex-1">
        <b>{count}</b> {noun}{count === 1 ? '' : 's'} awaiting Finance approval —
        not billable and hidden from dropdowns until approved.
      </p>
      <Button size="sm" variant="outline" className="shrink-0"
        onClick={() => navigate('/work-orders')}
        data-testid={`pending-approval-open-${kind}`}>
        Review
      </Button>
    </div>
  );
};

export default PendingApprovalBanner;
